import gsap from 'gsap';

// 1. Magnetic mouse effect
export function initMagneticButtons() {
  const elements = document.querySelectorAll('[data-magnetic-strength]');
  
  elements.forEach((el) => {
    const strength = parseFloat(el.getAttribute('data-magnetic-strength')) || 25;
    
    el.addEventListener('mousemove', (e) => {
      const bounds = el.getBoundingClientRect();
      const x = ((e.clientX - bounds.left) / el.offsetWidth - 0.5) * (strength / 16);
      const y = ((e.clientY - bounds.top) / el.offsetHeight - 0.5) * (strength / 16);
      
      gsap.to(el, {
        x: `${x}em`,
        y: `${y}em`,
        duration: 1,
        ease: 'power3.out'
      });
    });

    el.addEventListener('mouseleave', () => {
      gsap.to(el, {
        x: '0em',
        y: '0em',
        duration: 1.2,
        ease: 'elastic.out(1, 0.3)'
      });
    });
  });
}

// 2. Interactive Globe Mask follow movement
export function initGlobeMaskFollow() {
  const globeEl = document.querySelector('.globe-mask-follow');
  if (!globeEl) return;

  window.addEventListener('mousemove', (e) => {
    const val = 75 * (0.5 - e.clientX / window.innerWidth);
    gsap.to(globeEl, {
      duration: 1.6,
      ease: 'power2.out',
      '--mask-x': `${50 + val}%`
    });
  });
}

// 3. CTA & Nav Item Button Slide Hover Transitions
export function initButtonHovers() {
  document.querySelectorAll("[hover='btn']").forEach((btn) => {
    const textIdle = btn.querySelector("[hover='idle']");
    const textHover = btn.querySelector("[hover='hover']");
    
    if (textIdle && textHover) {
      btn.addEventListener('mouseenter', () => {
        gsap.to(textIdle, { yPercent: -100, opacity: 0, duration: 0.6, ease: 'power2.out' });
        gsap.to(textHover, { yPercent: -100, opacity: 1, duration: 0.6, ease: 'power2.out' });
      });

      btn.addEventListener('mouseleave', () => {
        gsap.to(textIdle, { yPercent: 0, opacity: 1, duration: 0.6, ease: 'power2.out' });
        gsap.to(textHover, { yPercent: 0, opacity: 0, duration: 0.6, ease: 'power2.out' });
      });
    }
  });
}
